<template>
    <div class="card-header pa-3">
        <div class="logo-container d-flex justify-space-between align-start">
            <div class="logo icon-logo d-flex align-center">
                <svg-icon :icon="logo" alt="logo" />
            </div>
            <div class="contact-info d-flex flex-column align-end">
                <span class="text-size-xxs text-black">
                    <svg-icon :icon="phone" alt="phone" />
                    <span class="ml-1">117</span>
                </span>
                <span class="text-size-xxs text-black">kolumbus.no</span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import SvgIcon from '@/features/common/components/SvgIcon.vue';
import logo from '@/assets/logo.svg';
import phone from '@/assets/phone.svg';
</script>
